import React, { useContext, useEffect, useState } from "react";
import { ReportParamsContext } from "../../context/ReportParamsContext";
import { getEntities, downloadRetailPrice } from "../../API";
import DropdownMultiSelect from "../../components/DropdownMultiSelect";

function normalizeResponse(response) {
  if (Array.isArray(response)) return response;
  if (response?._embedded) return Object.values(response._embedded).flat();
  if (response?.content) return response.content;
  return [];
}

export default function RetailPriceReport() {
  const [{ manufacturer, fromDate, toDate, representatives, itemStatus }] =
    useContext(ReportParamsContext);

  const [banners, setBanners] = useState([]);
  const [selectedBanners, setSelectedBanners] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getEntities("banners", "?size=1000").then((r) =>
      setBanners(normalizeResponse(r).sort((a, b) => a.name.localeCompare(b.name)))
    );
  }, []);

  const canGenerate = !!(manufacturer && fromDate && toDate && selectedBanners.length > 0);

  const handleDownload = async () => {
    if (!canGenerate) return;
    setDownloading(true);
    setError(null);
    try {
      await downloadRetailPrice({
        manufacturerId: manufacturer.id,
        fromDate,
        toDate,
        bannerIds: selectedBanners.map((b) => b.id),
        representativeIds: (representatives ?? []).map((r) => r.id),
        status: itemStatus,
      });
    } catch (e) {
      setError(e.message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="flex-grow-1 p-4 overflow-auto">
      <h5 className="mb-4">Retail Price</h5>

      <div className="row g-3 mb-4 align-items-end">
        <div className="col-md-4">
          <label className="form-label small mb-1">Banners</label>
          <DropdownMultiSelect
            options={banners}
            value={selectedBanners}
            onChange={setSelectedBanners}
            getOptionLabel={(o) => o.name}
            getOptionValue={(o) => o.id}
            placeholder="Select banners..."
          />
        </div>
      </div>

      {!manufacturer && (
        <p className="text-muted small mb-3">Select a manufacturer in the panel above.</p>
      )}
      {manufacturer && selectedBanners.length === 0 && (
        <p className="text-muted small mb-3">Select at least one banner.</p>
      )}

      {error && <div className="alert alert-danger">{error}</div>}

      <button className="btn btn-primary" onClick={handleDownload} disabled={!canGenerate || downloading}>
        {downloading ? "Generating…" : "Download Excel"}
      </button>
    </div>
  );
}
